export default __webpack_public_path__ + "static/media/Bracelet.1d2145aa.png";